<mijn-error [title]="'mijn.omgeving.error.' + errorContext + '.title' | apContent">
    <ap-content data-bb="errorContextMessage" key="{{ 'mijn.omgeving.error.' + errorContext + '.message' | apContent }}"> </ap-content>
    <ap-button
        [text]="true"
        data-bb="errorContextRedirect"
        ariaLabel="'mijn.omgeving.error.' + context + '.redirect.text' | apContent"
        (onClick)="redirect(errorContext)"
    >
        {{ 'mijn.omgeving.error.' + errorContext + '.redirect.text' | apContent }}
    </ap-button>
    @if (hasServiceLink(errorContext)) {
        <ap-button
            [text]="true"
            data-bb="errorContextRedirectService"
            ariaLabel="'mijn.omgeving.error.' + context + '.redirect.service.text' | apContent"
            (onClick)="toService(errorContext)"
        >
            {{ 'mijn.omgeving.error.' + errorContext + '.redirect.service.text' | apContent }}
        </ap-button>
    }
</mijn-error>
